// src/components/common/table/rowStatus.ts

import type { SxItem } from './sx';

export type TableRowStatus = 'normal' | 'warning' | 'error' | 'inactive';

export type GetRowStatus<T> = (row: T, index: number) => TableRowStatus;

const keepHover = (bg: string) => ({
  backgroundColor: bg,
  '&:hover': { backgroundColor: bg },
});

export const getRowStatusSx = (status: TableRowStatus): SxItem => {
  return (theme) => {
    switch (status) {
      case 'warning': {
        const bg =
          theme.palette.mode === 'light'
            ? theme.palette.warning.light
            : theme.palette.warning.dark;
        return keepHover(bg);
      }

      case 'error': {
        const bg =
          theme.palette.mode === 'light'
            ? theme.palette.error.light
            : theme.palette.error.dark;
        return keepHover(bg);
      }

      case 'inactive': {
        const bg =
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800];
        return keepHover(bg);
      }

      case 'normal':
      default:
        return {};
    }
  };
};
